import React from 'react'
import { formatFileSize } from './attachment-utils'

interface VideoAttachmentCardProps {
  attachment: {
    id: string
    url: string
    filename?: string
    mime_type?: string
    size?: number
  }
}

const VideoAttachmentCard: React.FC<VideoAttachmentCardProps> = ({
  attachment,
}) => {
  const videoUrl = attachment.url

  return (
    <div className="position-relative">
      <video
        preload="auto"
        src={videoUrl}
        controls
        className="rounded-xl"
        style={{
          maxWidth: '320px',
          maxHeight: '384px',
          width: '100%',
          height: 'auto',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          backgroundColor: '#000',
          borderRadius: '24px',
        }}
      >
        <track kind="captions" srcLang="en" label="English" />
        Your browser does not support the video tag.
      </video>
      <div
        className="mt-2 d-flex align-items-center"
        style={{ fontSize: '11px', opacity: 0.8 }}
      >
        <ion-icon
          name="videocam"
          style={{
            marginRight: '6px',
            fontSize: '14px',
            color: '#007bff',
          }}
        />
        <span className="text-truncate me-2" style={{ maxWidth: '200px' }}>
          {attachment.filename}
        </span>
        {attachment.size && (
          <span className="badge bg-secondary bg-opacity-50 ms-auto">
            {formatFileSize(attachment.size)}
          </span>
        )}
      </div>
    </div>
  )
}

export default VideoAttachmentCard
